function parseBooleanEnv(value: string | undefined): boolean | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return undefined;
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return undefined;
}

export function isDeliveryApprovalsEnabledServer(): boolean {
  return (
    parseBooleanEnv(process.env.DELIVERY_APPROVALS_ENABLED) ??
    parseBooleanEnv(process.env.NEXT_PUBLIC_DELIVERY_APPROVALS_ENABLED) ??
    process.env.NODE_ENV === 'development'
  );
}

/**
 * Provider prepares can dual-write canonical queue records before shared
 * confirmation is enforced. Enforcement always implies dual-write.
 */
export function isDeliveryApprovalsDualWriteEnabledServer(): boolean {
  return (
    isDeliveryApprovalsEnabledServer() ||
    (parseBooleanEnv(process.env.DELIVERY_APPROVALS_DUAL_WRITE_ENABLED) ?? false)
  );
}

export function isDeliveryApprovalsEnabledClient(): boolean {
  return (
    parseBooleanEnv(process.env.NEXT_PUBLIC_DELIVERY_APPROVALS_ENABLED) ??
    process.env.NODE_ENV === 'development'
  );
}
